import Page, { getServerSideProps } from 'pages/[lang]/features/travel-mode';

export default Page;

export { getServerSideProps };
